export const gtmService = (name, more = () => true) => ({
  key: "preferences",
  type: "api",
  name,
  uri: "",
  cookies: [],
  init: () => {},
  accept: () => {
    window.cookiesConsent.functionality_storage = "granted";
    window.cookiesConsent.personalization_storage = "granted";
    more();
  },
  deny: () => {
    window.cookiesConsent.functionality_storage = "denied";
    window.cookiesConsent.personalization_storage = "denied";
    more();
  },
  refuse: () => true,
});

export default gtmService;
